import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from "react";
import classNames from "classnames";
import memoize from "memoize-one";
var css = {
  "histogramWrapper": "rui-yoMQL",
  "histogramItem": "rui-3sMoE"
};
function computePercentages(data) {
  var max = Math.max.apply(Math, _toConsumableArray(data));
  return data.map(function (count) {
    return count / max * 100;
  });
}
var memoizedComputePercentages = memoize(computePercentages);
var Histogram = function Histogram(_ref) {
  var data = _ref.data,
    _ref$wrapperClass = _ref.wrapperClass,
    wrapperClass = _ref$wrapperClass === void 0 ? '' : _ref$wrapperClass,
    _ref$columnClass = _ref.columnClass,
    columnClass = _ref$columnClass === void 0 ? '' : _ref$columnClass;
  var percentages = memoizedComputePercentages(data);
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames(css.histogramWrapper, wrapperClass)
  }, percentages.map(function (percentage, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: classNames(css.histogramItem, columnClass),
      style: {
        height: "calc(".concat(percentage, "% + 1px)")
      }
    });
  }));
};
export default Histogram;